export const BROADCAST_STATE_KEY = 'travel_broadcast_state';

import { readJSONFromLocalStorage, writeJSONToLocalStorage } from '../consent/localStorage';

interface BroadcastStateElement {
    id: string;
    timeout: number;
}

const getBroadcastState = (): BroadcastStateElement[] => {
    const storage = readJSONFromLocalStorage<BroadcastStateElement[]>(BROADCAST_STATE_KEY);
    return Array.isArray(storage) ? storage : [];
};

export const filterDismissedBroadcasts = (messages) => {
    const dismissed = getBroadcastState().map((entry) => entry.id);

    return messages.filter((message) => !dismissed.includes(message.id));
};

export const dismissBroadcast = (broadcastId) => {
    const currentState = getBroadcastState();

    currentState.push({
        id: broadcastId,
        timeout: Date.now() + 1209600000, // two weeks
    });

    writeJSONToLocalStorage(BROADCAST_STATE_KEY, currentState);
};

export const purgeOutdatedBroadcasts = () =>
    writeJSONToLocalStorage(
        BROADCAST_STATE_KEY,
        getBroadcastState().filter((entry) => entry.timeout > Date.now()),
    );
